class PropertiesView {
  constructor({ element, propertyCardElements, properties }) {
    this.element = element;
    this.propertyElements = propertyCardElements;
    this._properties = properties;
    this.addPropertyEvents();
  }

  updatePropertyElements() {
    const updatedPropertyElements = document.querySelectorAll('.property_card');
    this.propertyElements = [...updatedPropertyElements];
    this.addPropertyEvents();
  }

  dispatchPropertyEvent(eventName, propertyElement) {
    const index = this.propertyElements.indexOf(propertyElement);
    const property = this._properties[index];
    this.element.dispatchEvent(new CustomEvent(eventName, {
      detail: {
        property,
        element: propertyElement
      }
    }));
  }

  findElementFromDom(propertyElement) {
    const id = propertyElement.getAttribute('id');
    return this.propertyElements.find(propertyElement => propertyElement.getAttribute('id') === id);
  }

  findElementFromEvent(event) {
    return this.findElementFromDom(event.currentTarget);
  }

  handlePropertyMouseOver = e => {
    const element = this.findElementFromEvent(e);
    this.dispatchPropertyEvent('property:mouseover', element);
  }

  handlePropertyMouseOut = e => {
    const element = this.findElementFromEvent(e);
    this.dispatchPropertyEvent('property:mouseout', element);
  }

  addPropertyEvents() {
    this.propertyElements.forEach(propertyElement => {
      propertyElement.addEventListener('mouseover', this.handlePropertyMouseOver);
      propertyElement.addEventListener('mouseout', this.handlePropertyMouseOut);
    });
  }

  removePropertyEvents() {
    this.propertyElements.forEach(propertyElement => {
      propertyElement.removeEventListener('mouseover', this.handlePropertyMouseOver);
      propertyElement.removeEventListener('mouseout', this.handlePropertyMouseOut);
    });
  }

  findProperty(propertyId) {
    return this._properties.find(property => property.id === propertyId);
  }

  findElementFromPropertyId(propertyId) {
    const property = this.findProperty(propertyId);
    if (!property) {
      return null;
    }
    const index = this._properties.indexOf(property);
    return this.propertyElements[index];
  }

  highlightProperty(propertyId) {
    const element = this.findElementFromPropertyId(propertyId);
    if (element) {
      element.classList.add('card-focused');
    }
  }

  unHighlightProperty(propertyId) {
    const element = this.findElementFromPropertyId(propertyId);
    if (element) {
      element.classList.remove('card-focused');
    }
  }

  unHighlightAllProperties() {
    this._properties.forEach(property => this.unHighlightProperty(property.id));
  }

  /**
   * Attach to events
   * - property:mouseover
   * - property:mouseout
   *
   * @param event
   * @param callback
   */
  on(event, callback) {
    this.element.addEventListener(event, callback);
  }

  off(event, callback) {
    this.element.removeEventListener(event, callback);
  }

  destroy() {
    this.removePropertyEvents();
    this.element = null;
    this.propertyElements = null;
    this._properties = null;
  }
}

export default PropertiesView;
